import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Box, FormControl, FormLabel, Grid, GridItem, Heading, Input } from '@chakra-ui/react'
import { UiSelect } from 'components/common'
import { getExistingSignOptions } from 'api'

export const EdgeExistingSignForm = ({ form, setForm, ...rest }) => {
  const loadExistingSignOptions = useCallback((page) => getExistingSignOptions(page, 20), [])

  return (
    <Box {...rest}>
      <Grid
        templateColumns="5fr 1fr"
        rowGap={5}
        columnGap={10}
        w="900px"
        maxW="100%"
      >
        <GridItem>
          <Heading size="md">Existing Sign</Heading>
        </GridItem>
        <GridItem></GridItem>
        <GridItem>
          <FormControl isRequired>
            <FormLabel>Existing Sign</FormLabel>
            <UiSelect
              value={form.existingSignOption}
              onChange={v => {
                setForm(draft => {
                  draft.existingSignOption = v
                  draft.existingSignCost = parseFloat((v?.cost || 0).toFixed(2))
                })
              }}
              loadData={loadExistingSignOptions}
              apiRespProp="rows"
              getOptionValue={v => v.id}
              getOptionLabel={v => `${v.description} - $${v.cost}`}
              placeholder="Search"
              noOptionsMessage={() => 'No Existing Sign Options Found'}
              isSearchable={false}
              required={true}
            />
          </FormControl>
        </GridItem>
        <GridItem display="flex" alignItems="flex-end">
          <FormControl>
            <FormLabel>Cost</FormLabel>
            <Input value={form.existingSignCost} readOnly />
          </FormControl>
        </GridItem>
      </Grid>
    </Box>
  )
}

EdgeExistingSignForm.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func
}
